import { render, staticRenderFns } from "./SApolloTable.vue?vue&type=template&id=00f216a7&scoped=true&"
import script from "./SApolloTable.vue?vue&type=script&lang=ts&"
export * from "./SApolloTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f216a7",
  null
  
)

export default component.exports